'use strict';

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["browsers", "esmodules", "node"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.array.sort.js");

var browserslist = require('browserslist');

var _require = require('./helpers'),
    compare = _require.compare,
    has = _require.has;

var external = require('./external');

var aliases = new Map([['and_chr', 'chrome'], ['and_ff', 'firefox'], ['ie_mob', 'ie'], ['ios_saf', 'ios'], ['op_mob', 'opera_mobile']]);
var validTargets = new Set(['android', 'chrome', 'edge', 'electron', 'firefox', 'ie', 'ios', 'node', 'opera', 'opera_mobile', 'phantom', 'safari', 'samsung']);

module.exports = function (targets) {
  if (typeof targets !== 'object' || Array.isArray(targets)) {
    targets = {
      browsers: targets
    };
  }

  var _targets = targets,
      browsers = _targets.browsers,
      esmodules = _targets.esmodules,
      node = _targets.node,
      rest = _objectWithoutProperties(_targets, _excluded);

  var list = Object.entries(rest);

  if (browsers) {
    list.push.apply(list, _toConsumableArray(browserslist(browsers).map(function (it) {
      return it.split(' ');
    })));
  }

  if (esmodules) {
    list.push.apply(list, _toConsumableArray(Object.entries(external.modules)));
  }

  if (node) {
    list.push(['node', node === 'current' ? process.versions.node : node]);
  }

  var normalized = list.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        engine = _ref2[0],
        version = _ref2[1];

    if (has(browserslist.aliases, engine)) {
      engine = browserslist.aliases[engine];
    }

    if (aliases.has(engine)) {
      engine = aliases.get(engine);
    }

    return [engine, String(version)];
  }).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        engine = _ref4[0];

    return validTargets.has(engine);
  }).sort(function (_ref5, _ref6) {
    var _ref7 = _slicedToArray(_ref5, 1),
        a = _ref7[0];

    var _ref8 = _slicedToArray(_ref6, 1),
        b = _ref8[0];

    return a < b ? -1 : a > b ? 1 : 0;
  });
  var reducedByMinVersion = new Map();

  var _iterator = _createForOfIteratorHelper(normalized),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          engine = _step$value[0],
          version = _step$value[1];

      if (!reducedByMinVersion.has(engine) || compare(version, '<=', reducedByMinVersion.get(engine))) {
        reducedByMinVersion.set(engine, version);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return reducedByMinVersion;
};